/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-15 10:52:20
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  upload: '上传',
  unUpload: '未上传',
  unDevelop: '敬请期待',
  waiting: '等待中',
  deleteTip: '确认删除安装包?',
  select: '请选择',
  finish: '已完成',
  config: '配置',
  version: '版本',
  requiredNull: '该组件为必选',
});
